var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGreenSheetsArena(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.882,
    height: 86.971,
    viewBox: "0 0 88.882 86.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 7.604,
    y: 0.9,
    width: 81.278,
    height: 83.498,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 7.241,
    y: 39.021,
    width: 36.127,
    height: 40.808,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 20.352,
    y: 39.487,
    width: 38.235,
    height: 29.757,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 51.361,
    y: 31.865,
    width: 30.675,
    height: 34.923,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 20.061,
    y: 5.762,
    width: 37.765,
    height: 37.717,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 0,
    y: 0,
    width: 86.974,
    height: 86.971,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 24.753,
    y: 27.794,
    width: 55.308,
    height: 25.869,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "n"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "n"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: 24.711,
    y: 23.853,
    width: 55.353,
    height: 25.854,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "p"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "p"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: 24.747,
    y: 31.758,
    width: 45.747,
    height: 25.849,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "r"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "r"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    x: 29.956,
    y: 18.812,
    width: 44.84,
    height: 25.852,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "t"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "t"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    x: 24.707,
    y: 35.715,
    width: 33.203,
    height: 25.85,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "v"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "v"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w",
    x: 48.967,
    y: 31.755,
    width: 31.095,
    height: 25.852,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "x"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "x"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1203.26 -1190.029)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 44,
    transform: "translate(1221.5 1216)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-499.875 530.825)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1703.13, 659.2)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.868,8.676a11.823,11.823,0,0,1,.063,5.876c2.088.565,3.1,2.152,3.9,3.937a26.48,26.48,0,0,1,1.874,7.8,28.6,28.6,0,0,0,.578,3.2,6.054,6.054,0,0,0,1.379,2.637,25.394,25.394,0,0,1,1.849,2.529,1.21,1.21,0,1,1-2.016,1.312,16.434,16.434,0,0,0-4.906-5.19A11.628,11.628,0,0,0,25.38,29.617a1.747,1.747,0,0,0-.637.449A23.729,23.729,0,0,1,18.1,34.657a1.1,1.1,0,0,1-1.37-.113,1.534,1.534,0,0,1-.412-1.12,1.783,1.783,0,0,1,.807-.965c1.372-.844,2.782-1.624,4.264-2.477-5.42-3.038-10.541-3.425-16.658.791-.152.1-.292.226-.44.337a1.214,1.214,0,1,1-1.507-1.886,18.755,18.755,0,0,1,8.38-3.766,14.707,14.707,0,0,1,9.7,1.583,4.405,4.405,0,0,0,3.564.318,14.445,14.445,0,0,1,11.78.96,1.57,1.57,0,0,0,.257.082c-.3-3.415-.653-6.772-2.307-9.828a2.891,2.891,0,0,0-1.95-1.7,27.952,27.952,0,0,1-2.2,2.9A11.121,11.121,0,0,1,17.89,22.816a11.167,11.167,0,0,1-7.967-9.643A11.716,11.716,0,0,1,31.447,5.459a1.262,1.262,0,0,0,.766.469A5.9,5.9,0,0,1,36.5,8.6a4.261,4.261,0,0,0,1.634,1.443A38.618,38.618,0,0,1,52.952,23.585a52.48,52.48,0,0,1,5.765,11.241,10.173,10.173,0,0,1,.764,2.555,5.469,5.469,0,0,1-1.807,4.1,14.1,14.1,0,0,1-5.09,3.464c-2.672,1.141-5.357,2.272-7.945,3.587a28.191,28.191,0,0,1-16.849,2.691,22.909,22.909,0,0,1-6.709-1.909c-1.441-.667-1.513-.607-1.934.919a18.539,18.539,0,0,1-1.614,4.689,11.223,11.223,0,0,1-4.779,4.388,1.222,1.222,0,0,1-1.781-.492,1.206,1.206,0,0,1,.69-1.664A8.656,8.656,0,0,0,16.4,51.2a22.349,22.349,0,0,1,.853-2.883,2.576,2.576,0,0,1,3.338-1.727,7.806,7.806,0,0,1,1.506.518,23.138,23.138,0,0,0,9.918,2,26.473,26.473,0,0,0,12.761-3.345c2.185-1.154,4.5-2.074,6.783-3.025a10.973,10.973,0,0,0,4.5-3.118,6.932,6.932,0,0,0,.974-1.814,1.469,1.469,0,0,0-.064-1.011,75.659,75.659,0,0,0-4.361-9.14,41.354,41.354,0,0,0-10.6-12.329,41.66,41.66,0,0,0-4.63-2.9,9.206,9.206,0,0,1-3.144-2.779,8.069,8.069,0,0,0-1.162-1.115l-.2.135m-2.021,3.063a9.306,9.306,0,1,0-9.391,9.278,9.273,9.273,0,0,0,9.391-9.278",
    transform: "translate(17.39 12.9)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1703.13, 659.2)",
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,247.441a17.228,17.228,0,0,1,6.38-12.24A32.035,32.035,0,0,1,10,232.667c.873-.556,1.59-.4,1.966.291s.083,1.316-.806,1.832a17.523,17.523,0,0,0-7.718,8.4A14.15,14.15,0,0,0,2.415,247.6c-.089,1.1-.544,1.6-1.338,1.531-.771-.068-1.116-.614-1.073-1.692",
    transform: "translate(19.24 -181.31)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1703.13, 659.2)",
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.8,237.693c-1.4-.43-2.465.405-3.552,1.253a8.435,8.435,0,0,1-7.2,1.788,4.691,4.691,0,0,1-1.606-.711,1.216,1.216,0,1,1,1.455-1.945,4.167,4.167,0,0,0,3.212.26,7.2,7.2,0,0,0,3.062-1.62,5.688,5.688,0,0,1,4.336-1.517,3.472,3.472,0,0,1,.892.2,1.177,1.177,0,0,1,.712,1.349,1.237,1.237,0,0,1-1.316.942",
    transform: "translate(-47.55 -183.68)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1703.13, 659.2)",
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.571,193.07a6.05,6.05,0,0,1-2.388,4.79,17.827,17.827,0,0,1-2.4,1.58,1.192,1.192,0,0,1-1.741-.446,1.248,1.248,0,0,1,.623-1.7,15.877,15.877,0,0,0,2.209-1.532,3.5,3.5,0,0,0,.641-4.77c-.074-.123-.16-.238-.233-.361a1.194,1.194,0,0,1,.294-1.684,1.171,1.171,0,0,1,1.68.31,6.448,6.448,0,0,1,1.317,3.811",
    transform: "translate(-205.53 -144.86)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1703.13, 659.2)",
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.019,29.63a6.859,6.859,0,1,1-6.885,6.8,6.863,6.863,0,0,1,6.885-6.8m-4.456,6.845a4.45,4.45,0,1,0,4.472-4.439,4.463,4.463,0,0,0-4.472,4.439",
    transform: "translate(-46.07 -11.87)",
    fill: "#09d7d7"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 63,
    transform: "translate(1213.5 1201)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.26 34.337)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1108, 1155.69)",
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,0c.46.276.772.649.584,1.211s-.666.639-1.2.639a2.508,2.508,0,0,0-2.741,2.7q-.009,20.594,0,41.189c0,.141.016.283.029.5.6,0,1.184,0,1.771,0a3.032,3.032,0,0,1,3.164,3.176c.007.777,0,1.555,0,2.394.254.012.473.031.692.031q16.476,0,32.951,0a2.579,2.579,0,0,0,2.871-2.894q0-12.449,0-24.9a7.637,7.637,0,0,0-7.854-7.9c-1-.007-2.008.012-3.012,0a3.33,3.33,0,0,1-3.437-3.4c-.032-1.331.035-2.668-.073-3.993a7.548,7.548,0,0,0-7.492-6.9c-3.975-.023-7.951-.008-11.926,0-.454,0-.875-.049-1.107-.494-.313-.6.028-1,.467-1.354H44.273a1.944,1.944,0,0,0,.341.108,11.656,11.656,0,0,1,6.815,3.237Q55.567,7.38,59.6,11.519a11.288,11.288,0,0,1,3.337,7.971c.055,9.96.033,19.92.017,29.88a4.326,4.326,0,0,1-4.011,4.292c-.278.026-.556.049-.824.072a1.882,1.882,0,0,0-.049.231c-.174,3.038-1.834,4.6-4.889,4.6H16.725c0,.5.008.924,0,1.353a3.046,3.046,0,0,1-3.06,3.04c-.84.014-1.681.006-2.521,0a3.076,3.076,0,0,1-3.257-3.285c-.005-1.332.019-2.665-.015-4a2.191,2.191,0,0,0-.311-.985.931.931,0,0,1,.34-1.364A1.182,1.182,0,0,1,9.727,54.43c0,1.763-.005,3.525,0,5.287a1.244,1.244,0,0,0,1.4,1.4c.758.008,1.517,0,2.275,0,1.027-.005,1.468-.437,1.471-1.451.005-1.742,0-3.484,0-5.226,0-.91.3-1.2,1.222-1.2,1.763,0,3.525.008,5.287,0a1.226,1.226,0,0,0,1.37-1.367c.009-.779.006-1.558,0-2.336-.007-1.025-.431-1.445-1.467-1.448-1.721,0-3.443,0-5.164,0-.953,0-1.248-.3-1.249-1.244,0-1.721,0-3.443,0-5.164,0-1.039-.423-1.465-1.443-1.47q-1.107-.006-2.213,0c-1.068,0-1.49.42-1.494,1.488,0,1.68,0,3.361,0,5.042,0,1.09-.255,1.349-1.324,1.35-1.721,0-3.443,0-5.164,0a1.236,1.236,0,0,0-1.393,1.4c-.006.553,0,1.107,0,1.66,0,1.854.183,2.044,2.012,2.09.041,0,.082,0,.123,0a.92.92,0,0,1,.935.868.9.9,0,0,1-.849.953A6.711,6.711,0,0,1,2.6,55.03,3.2,3.2,0,0,1,0,52.636V48.7a1.442,1.442,0,0,0,.111-.211,3.047,3.047,0,0,1,3.078-2.248c.512,0,1.024,0,1.536,0H7.814a.951.951,0,0,0,.059-.187c0-1.5,0-2.991.012-4.486a3.047,3.047,0,0,1,3.2-3.206c.588,0,1.175,0,1.819,0v-.8q0-14.074,0-28.149a4.358,4.358,0,0,1,3.559-4.444,12.4,12.4,0,0,1,1.3-.116c.016-.257.032-.478.044-.7A4.136,4.136,0,0,1,19.835.7,10.875,10.875,0,0,1,21.521,0ZM17.768,6.8a2.5,2.5,0,0,0-3.013,2.489q-.015,14.415.009,28.829a.832.832,0,0,0,.356.593,3.1,3.1,0,0,1,1.6,2.788c.008,1.373,0,2.746,0,4.118V46.2h1.043ZM16.75,56.726H53.126a8.266,8.266,0,0,0,.921-.029,2.44,2.44,0,0,0,2.071-3.006h-.78q-14.782,0-29.564-.006c-.9,0-1.756-.071-2.419.766a2.208,2.208,0,0,1-1.145.528,4.993,4.993,0,0,1-1.217.1c-1.406.011-2.813,0-4.243,0ZM45.229,2.206c.094.077.192.15.283.23.107.095.212.193.313.295A9.066,9.066,0,0,1,48.59,8.665c.084,1.306.044,2.621.069,3.931A1.529,1.529,0,0,0,50.369,14.3c.983.013,1.967,0,2.95,0a9.491,9.491,0,0,1,7.253,3.186c.072.079.157.146.319.294A9.59,9.59,0,0,0,58.445,13q-4.19-4.284-8.475-8.475a8.5,8.5,0,0,0-4.741-2.315",
    transform: "translate(12 12)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1108, 1155.69)",
    filter: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.249,171.026q-7.163,0-14.326,0c-.224,0-.525.062-.657-.055-.265-.235-.6-.575-.6-.868s.352-.622.621-.852c.138-.117.432-.066.656-.066q14.356,0,28.713,0c.082,0,.164,0,.246,0,.656.025,1.078.395,1.072.938s-.424.9-1.091.9q-5.5.006-11.006,0h-3.628",
    transform: "translate(-113.91 -129.38)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1108, 1155.69)",
    filter: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.038,147.037H151.774a2.781,2.781,0,0,1-.613-.023.914.914,0,0,1,.064-1.81,3.8,3.8,0,0,1,.553-.01h28.775c.766.005,1.206.341,1.2.921s-.442.923-1.207.923q-7.255,0-14.51,0",
    transform: "translate(-113.69 -109.33)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1108, 1155.69)",
    filter: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.491,195.146c-3.214,0-6.428,0-9.641-.006a1.336,1.336,0,0,1-.812-.156,1.238,1.238,0,0,1-.408-.863,1.167,1.167,0,0,1,.547-.716,1.524,1.524,0,0,1,.775-.1q9.519-.007,19.037,0c.143,0,.287-.007.43,0a.919.919,0,0,1,.957.913.893.893,0,0,1-1,.92c-1.576.014-3.152.006-4.729.006h-5.158",
    transform: "translate(-113.88 -149.54)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1108, 1155.69)",
    filter: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.777,114.507h9.093a2.539,2.539,0,0,1,.551.021.914.914,0,0,1,.039,1.79,2.356,2.356,0,0,1-.611.032q-9.093,0-18.186,0a2.52,2.52,0,0,1-.612-.028.915.915,0,0,1,.02-1.792,2.941,2.941,0,0,1,.612-.023h9.093",
    transform: "translate(-140.37 -83.69)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1108, 1155.69)",
    filter: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.978,219.232c-1.166,0-2.331.008-3.5,0-.712-.006-1.08-.316-1.1-.883-.017-.591.366-.948,1.1-.952q3.5-.018,6.994,0c.7,0,1.132.4,1.111.954-.021.537-.432.876-1.113.882-1.166.01-2.331,0-3.5,0",
    transform: "translate(-113.68 -169.67)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1108, 1155.69)",
    filter: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.563,195.13c-.818,0-1.635.009-2.452,0-.658-.01-1.075-.386-1.064-.927a.947.947,0,0,1,1.033-.908q2.514-.022,5.028,0a.946.946,0,0,1,1.034.907c.011.541-.406.917-1.064.927-.838.012-1.676,0-2.514,0",
    transform: "translate(-237.08 -149.53)",
    fill: "#09d7d7"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenSheetsArena);
export default __webpack_public_path__ + "static/media/icon-green-sheets-arena.0de94887206ca945cd697958cb307ff6.svg";
export { ForwardRef as ReactComponent };